import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=dfb13520&scoped=true&"
import script from "./uploadImage.vue?vue&type=script&lang=js&"
export * from "./uploadImage.vue?vue&type=script&lang=js&"
import style0 from "./uploadImage.vue?vue&type=style&index=0&id=dfb13520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb13520",
  null
  
)

export default component.exports